import React from 'react'
import { 
    Button, 
} from 'antd'
import './Dashboard.scss'
import { firAuth } from '../../service/firebase'
import {Switch, Route, Redirect} from 'react-router-dom'

import Sidebar from '../../components/Sidebar/Sidebar'
import Summary from './summary/Summary'
import CalendarEvent from './event/CalendarEvent'
import Sight from './sight/Sight'
import Picture from './picture/Picture'
import PersonalTaste from './taste/PersonalTaste'
import Notable from './notable/Notable'
import TownTrivia from './trivia/TownTrivia'
import ExclusiveOffer from './offer/ExclusiveOffer'
import Settings from './settings/Settings'
import User from './user/User'
import AskLocal from './ask/AskLocal'
import Sponsor from './sponsor/Sponsor'
import LearnMore from './learn/LearnMore'
import Notification from './notification/Notification'



export default class Dashboard extends React.Component {
    
    state = {
        collapsed: false,
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleMenuSelect(route) {
        this.props.history.push('/dashboard/' + route)
    }

    handleCollapse() {
        this.setState({collapsed: !this.state.collapsed})
    }

    handleLogout() {
        firAuth.signOut()
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {
        let width = 250
        if(this.state.collapsed) width = 70
        let cls = ''
        if(this.state.collapsed) cls = ' collapsed'

        return (
            <div className="dashboard">

                <div className={"left-side" + cls} style={{width: width}}>
                    <Sidebar menuSelect={route => this.handleMenuSelect(route)} />
                </div>

                <div className="right-side" style={{left: width}}>

                    <div className="top-nav">
                        <div className="top-nav-left">
                            <Button className="btn-fold" ghost
                                type="primary" 
                                icon={this.state.collapsed ? "menu-unfold" : 'menu-fold'}
                                onClick={() => this.handleCollapse()}></Button>
                        </div>

                        <div className="top-nav-right">
                            Admin
                            <Button ghost
                                style={{color: 'white', borderColor: 'white'}}
                                type="primary" 
                                icon='logout'
                                onClick={() => this.handleLogout()}></Button>
                        </div>
                    </div>

                    <div className="main-content">

                        <Switch>
                            <Route exact path="/dashboard" render={() => <Redirect to="/dashboard/summary" />} />
                            <Route exact path="/dashboard/summary" render={(props) => <Summary {...props} />} />
                            <Route exact path="/dashboard/event" render={(props) => <CalendarEvent {...props} />} />
                            <Route exact path="/dashboard/sight" render={(props) => <Sight {...props} />} />
                            <Route exact path="/dashboard/taste" render={(props) => <PersonalTaste {...props} />} />
                            <Route exact path="/dashboard/notable" render={(props) => <Notable {...props} />} />
                            <Route exact path="/dashboard/trivia" render={(props) => <TownTrivia {...props} />} />
                            <Route exact path="/dashboard/sponsor" render={(props) => <Sponsor {...props} />} />
                            <Route exact path="/dashboard/offer" render={(props) => <ExclusiveOffer {...props} />} />
                            <Route exact path="/dashboard/ask" render={(props) => <AskLocal {...props} />} />
                            <Route exact path="/dashboard/learn" render={(props) => <LearnMore {...props} />} />
                            <Route exact path="/dashboard/settings" render={(props) => <Settings {...props} />} />
                            <Route exact path="/dashboard/user" render={(props) => <User {...props} />} />
                            <Route exact path="/dashboard/picture" render={(props) => <Picture {...props} />} />
                            <Route exact path="/dashboard/notification" render={(props) => <Notification {...props} />} />

                            <Route render={() => <div style={{color: '#00315c', fontSize: 16, fontWeight: 'bold'}}>Coming Soon</div>} />
                        </Switch>

                    </div>

                </div>

            </div>
        )
    }
}
